import { apiUrl } from '../../lib/build';
export class CashRequestError extends Error {
  constructor(
    message: string,
    public status: number,
  ) {
    super(message);
  }
}
export async function request<T>(
  path: string,
  body?: unknown,
  signal?: AbortSignal,
): Promise<T> {
  const response = await fetch(apiUrl('/v1/book/workspace' + path), {
    credentials: 'same-origin',
    cache: 'no-store',
    signal,
    ...(body === undefined
      ? {}
      : {
          method: 'POST',
          headers: { 'content-type': 'application/json' },
          body: JSON.stringify(body),
        }),
  });
  const data = (await response.json().catch(() => null)) as {
    detail?: unknown;
  } | null;
  if (!response.ok)
    throw new CashRequestError(
      typeof data?.detail === 'string'
        ? data.detail
        : response.status === 401
          ? 'войдите в сервис ещё раз'
          : 'данные не обновились. попробуйте ещё раз',
      response.status,
    );
  return data as T;
}
